import React, { Component } from 'react';
import axios from 'axios';
import lottie from 'lottie-web';

class Animation extends Component {
  componentDidMount () {
    const { options, path, isPlay } = this.props;

    const {
      loop,
      autoplay,
    } = options;

    this.options = {
      container: this.el,
      renderer: 'svg',
      loop: loop !== false,
      autoplay: autoplay !== false,
      rendererSettings: {
        className: 'notranslate',
      },
    };

    this.options = {
      ...this.options,
      ...options,
    };

    this.loadAnimation(path).then((response) => {
      this.options.animationData = response.data;
      this.animation = lottie.loadAnimation(this.options);
      this.animation.addEventListener('complete', this.handleAnimationComplete);

      if (isPlay) {
        this.play();
      }
    });
  }

  componentDidUpdate (prevProps) {
    const { path, isPlay } = this.props;
    if (prevProps.path !== path) {
      this.options = {
        ...prevProps.options,
        ...this.options,
      };

      this.loadAnimation(path).then((response) => {
        this.destroy();
        this.options.animationData = response.data;
        this.animation = lottie.loadAnimation(this.options);
        this.animation.removeEventListener('complete', this.handleAnimationComplete);
        this.animation.addEventListener('complete', this.handleAnimationComplete);

        if (isPlay) {
          this.play();
        }
      });
    }

    if (!prevProps.isPlay && isPlay) {
      this.play();
    }
  }

  componentWillUnmount () {
    this.destroy();
    this.animation = null;
  }

  handleAnimationComplete = () => {
    const { callback } = this.props;
    this.animation.goToAndStop(0);
    if (callback) {
      callback();
    }
  }

  loadAnimation (path) {
    return axios({
      method: 'GET',
      url: path,
    });
  }

  play () {
    if (this.animation) {
      this.animation.play();
    }
  }

  stop () {
    this.animation.stop();
  }

  pause () {
    this.animation.pause();
  }

  destroy () {
    if (this.animation) {
      this.animation.destroy();
    }
  }

  render () {
    const { className } = this.props;

    return <div ref={(n) => {
      this.el = n;
    }} className={className} />;
  }
}

Animation.displayName = 'Animation';

export default Animation;
